
import { Component, Vue } from "vue-property-decorator";
import NotificationTemplate from "@/components/NotificationTemplate/NotificationTemplate.vue";
import { NOTIFICATION_PROPS } from "@/constants/notification";

@Component({
  components: {
    NotificationTemplate,
  },
})
export default class NotificationServiceEmployeeStarted extends Vue {
  notificationProps = NOTIFICATION_PROPS;

  get text() {
    return this.$t("text.employee");
  }
}
